import { render } from "./TotalRecap.vue?vue&type=template&id=d476090e"
import script from "./TotalRecap.vue?vue&type=script&lang=js"
export * from "./TotalRecap.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__